module.exports = __webpack_public_path__ + "img/profile-card.548da5c2.svg";